module.exports = __webpack_public_path__ + "static/media/degraded.c0ddcb25.svg";